export const getQueuedRecipientsText = (recipients: number): string => {
    if (recipients === 0) {
        return 'No recipients queued';
    }

    return `${recipients} ${recipients === 1 ? 'recipient' : 'recipients'} queued`;
};
